@if (shouldShowInstallPrompt()) {
	<div class="pwa-install-prompt">
		<img [src]="spotLogo.src" class="logo" [alt]="spotLogo.alt">
		<button class="btn-none download-btn" translate="pwa-install-message" [translateParams]="translationParams" (click)="showiOSorAndroidInstall()"></button>
		<button class="btn-none close-btn" aria-label="dismiss pwa install prompt" (click)="setHasSeenPWAInstallPrompt()">
			<i class="ficon-times"></i>
		</button>
	</div>
}
